import React, { FC, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  Row,
  Col,
  Input,
  Button,
  Select,
  Collapse,
  Image,

} from "antd";
import { ReactSVG } from "react-svg";
import _, { stubObject } from "lodash";
import { Form } from "antd";
import { useLocation } from "react-router-dom";
import { SocketTopics } from "constants/enums";
import { wrapRequestPayload } from "../../../../helpers/request/RequestPayload";
import {
  getProjectsRequestPublishTopic,
  getProjectsSubscriptionTopic,
  getRespondersRequestPublishTopic,
  getRespondersSubscriptionTopic,
  getAssetsSubscriptionTopic,
  getCreateEventPageSubscriptionTopic,
  getCreateEventPagePublishTopic,
  getPageRequestPublishTopic,
  getPageSubscriptionTopic,
} from "hooks/MQTTConstants";
import useLocalStorageService from "../../../../services/localStorage";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";
import {
  SET_CURRENT_LOCATION,
  SET_CURRENT_PROJECT,
  SET_SUBMITTED,
  ADD_OTHER_LOCATION,
  REMOVE_OTHER_LOCATION,
} from "reducers/reducer";
import { pushNotification } from "utils/notifications";
import { ReloadOutlined } from "@ant-design/icons";
import moment from "moment";
import LocationInput from "../../../../common/LocationInput";
import RenderFields from "../../../../common/RenderFields";
import DateInput from "../../../../common/DateInput";
import TimeInput from "../../../../common/TimeInput";
import MultiInput from "../../../../common/MultiInput";
import { formatObject } from "utils/appUtil";

const { Option } = Select;

const { TextArea } = Input;

const { Panel } = Collapse;

const DispatchPanel: FC<{ socket: ISocket; params: any }> = ({
  socket,
  params,
}) => {
  const [nine11Form] = Form.useForm();
  const [error, setError] = useState<string>("");
  const { screens, setScreens } = params;
  const { search } = useLocation();
  const history = useHistory();
  const { getLocalStorageItem } = useLocalStorageService();
  const { projects } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();
  const {
    selectedResponders,
    selectedAssets,
    submitted,
    otherLocations,
    page,
    encrypted_token
  } = useSelector((state: RootState) => state.auth);
  const [searching, setSearching] = useState<boolean>(false);
  const [uploadModalVisible, setUploadModalVisible] = useState<boolean>(false);
  const [saving, setSaving] = useState<boolean>(false);
  const [pageId, setPageId] = useState<boolean>(false);
  const [priorityOptions, setPriorityOptions] = useState([]);
  const [whoOptions, setWhoOptions] = useState([]);
  const [cadSections, setCadSections] = useState([]);
  const [cadExtendedSections, setCadExtendedSections] = useState({
    what: [],
    account: [],
    where: [],
    who: [],
    when: [],
    why: [],
  });

  const onSubmitHandler = (values: Nine11Values) => {
    // const query = new URLSearchParams(search);
    // const userId = query.get("userId");
    // const connectionId = query.get("connectionId");
    if (values["undefined"]) {
      _.merge(values, values["undefined"]);
      delete values["undefined"];
    }

    const responders = selectedResponders.map((responder) => {
      return {
        id: responder.id,
        beamId: responder.title,
      };
    });
    const assets = selectedAssets.map((asset) => {
      return {
        id: asset.id,
        title: asset.title,
        location: asset.location,
      };
    });
    const extendedAttributes = {};
    Object.keys(values).map((key) => {
      _.merge(
        extendedAttributes,
        formatObject(key, key, values[key], cadSections, cadExtendedSections)
      );
    });
    const project = projects?.projects?.find((x) => {
      return x.id === extendedAttributes["incidentType"];
    });
    const sortedAttributes = {
      ...extendedAttributes,
      accountNumber: extendedAttributes["accountNumber"],
      accountName: extendedAttributes["accountName"],
      accountContactName: extendedAttributes["accountContactName"],
      accountContactPhone: extendedAttributes["accountContactPhone"],
      accountContactEmail: extendedAttributes["accountContactEmail"],
      incidentLocation: {
        ...extendedAttributes["incidentLocation"],
        type: "incident-location",
      },
      incidentType: {
        id: extendedAttributes["incidentType"],
        type: "project",
      },
      incidentTypeName: project?.name,
      incidentPriority: extendedAttributes["incidentPriority"]?.toString(),
      incidentProtocols: extendedAttributes["incidentProtocols"],
      incidentDate: moment(extendedAttributes["incidentDate"])?.format(
        "MM/DD/YYYY"
      ),
      incidentTime: moment(extendedAttributes["incidentTime"])?.format(
        "HH:mm:ss"
      ),
      incidentDescription: extendedAttributes["incidentDescription"],
      callerLocation: extendedAttributes["callerLocation"],
    };

    setError(undefined);
    setSearching(true);
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getCreateEventPagePublishTopic(encrypted_token?.connectionId),
      wrapRequestPayload({
        userId: encrypted_token?.userId,
        attributes: sortedAttributes,
        responders,
        assets,
        connectionId: encrypted_token?.connectionId,
        pageId,
        submitted: true,
        unstructuredAttributes: values,
        invitation: true,
      })
    );
  };

  const onSave = () => {
    // const query = new URLSearchParams(search);
    // const userId = query.get("userId");
    // const connectionId = query.get("connectionId");
    const values = nine11Form.getFieldsValue();
    setSaving(true);
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getCreateEventPagePublishTopic(encrypted_token?.connectionId),
      wrapRequestPayload({
        userId: encrypted_token?.userId,
        attributes: values,
        responders: [],
        assets: [],
        connectionId: encrypted_token?.connectionId,
        pageId,
        submitted: false,
      })
    );
  };

  useEffect(() => {
    if (submitted) {
      if (searching) {
        setSearching(false);
        setPageId(undefined);
        pushNotification(
          "Event page submitted successfully",
          "success",
          "TOP_CENTER",
          1000
        );
        localStorage.removeItem("form");
        localStorage.removeItem("active");

        setTimeout(() => {
          nine11Form.resetFields();
        }, 500);
        // setScreens({
        //   ...screens,
        //   map: false,
        // });
        // const query = new URLSearchParams(search);
        // query.delete("pageId");
        // history.replace({
        //   search: query.toString(),
        // });
        dispatch({ type: SET_SUBMITTED, payload: false });
      } else if (saving) {
        setSaving(false);
        setPageId(submitted.pageId);
        pushNotification(
          "Event page saved successfully",
          "success",
          "TOP_CENTER",
          1000
        );
        // const query = new URLSearchParams(search);
        // query.delete("pageId");
        // query.append("pageId", submitted.pageId);
        // history.replace({
        //   search: query.toString(),
        // });
      }
    }
  }, [
    dispatch,
    history,
    nine11Form,
    saving,
    screens,
    search,
    searching,
    setScreens,
    submitted,
  ]);

  useEffect(() => {
    if (projects?.settings) {
      const who = [];
      const priority = [];
      projects?.settings?.whoTags?.map((tag) => {
        who.push({ label: tag, value: tag });
      });
      Array.from(Array(projects?.settings?.eventPriority ?? 0).keys())?.map(
        (op) => {
          priority.push({ label: op + 1, value: op + 1 });
        }
      );
      if ((projects?.settings?.eventPriority ?? 0) === 0) {
        priority.push({ label: 1, value: 1 });
        priority.push({ label: 2, value: 2 });
        priority.push({ label: 3, value: 3 });
      }
      setPriorityOptions(priority);
      setWhoOptions(who);
    }
  }, [projects]);

  useEffect(() => {
    if (encrypted_token) {
      // const query = new URLSearchParams(search);
      // const userId = query.get("userId");
      // const connectionId = query.get("connectionId");
      // const pageId = query.get("pageId");

      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getProjectsSubscriptionTopic(encrypted_token?.connectionId)
      );
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getRespondersSubscriptionTopic(encrypted_token?.connectionId)
      );
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getAssetsSubscriptionTopic(encrypted_token?.connectionId)
      );
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getCreateEventPageSubscriptionTopic(encrypted_token?.connectionId)
      );
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getPageSubscriptionTopic(encrypted_token?.connectionId)
      );
      socket.publishToEvent(
        SocketTopics.PublishPageTopics,
        getProjectsRequestPublishTopic(encrypted_token?.connectionId),
        wrapRequestPayload({
          userId: encrypted_token?.userId,
        })
      );
    }
  }, [encrypted_token]);

  const onProjectChange = (projectId) => {
    dispatch({ type: SET_CURRENT_PROJECT, payload: projectId });
  };

  const addOtherLocation = (location) => {
    dispatch({ type: ADD_OTHER_LOCATION, payload: location });
    nine11Form.setFieldsValue({
      incidentType: undefined,
    });
    dispatch({
      type: SET_CURRENT_PROJECT,
      payload: undefined,
    });
  };

  const removeOtherLocation = (index) => {
    dispatch({ type: REMOVE_OTHER_LOCATION, payload: index });
    nine11Form.setFieldsValue({
      incidentType: undefined,
    });
    dispatch({
      type: SET_CURRENT_PROJECT,
      payload: undefined,
    });
  };

  return (
    <div className="main-column ride-dispatch-panel mobile-responsive mr-4" style={{height: "auto"}}>
      <div className="main-content">
        <Form
          className="auth-form"
          name="register-form"
          // initialValues={JSON.parse(localStorage.getItem("form") || "{}")}
          initialValues={{}}
          id="register-form"
          layout="vertical"
          form={nine11Form}
          onFinish={onSubmitHandler}
          requiredMark={false}
          onValuesChange={(value, allValues) => {
            localStorage.setItem("form", JSON.stringify(allValues));
          }}
        >
          <div className="main-header">
            <div className="d-flex">
              <Image src="/images/incident-icon.png" preview={false} />
              <h3 className="ml-3">911</h3>
            </div>
            <div className="d-flex">
              <ReactSVG
                src="/images/close-icon.svg"
                className="close-icon"
                onClick={() => {
                  setTimeout(() => {
                    localStorage.removeItem("form");
                    localStorage.removeItem("form");
                    dispatch({ type: SET_SUBMITTED, payload: false });
                    nine11Form.resetFields();
                    // setScreens({
                    //   ...screens,
                    //   map: false,
                    // });
                    // const query = new URLSearchParams(search);
                    // query.delete("pageId");
                    // history.replace({
                    //   search: query.toString(),
                    // });
                  });
                }}
              />
            </div>
          </div>
          <Row className="mt-3">
            <Col span={24}>
              <Form.Item name="feature">
                <Select className="w-full" placeholder="Features"></Select>
              </Form.Item>
            </Col>
          </Row>
          <div className="main-cards" style={{ maxHeight: "calc(100vh - 100px)" }}>
            <Collapse
              defaultActiveKey={JSON.parse(
                localStorage.getItem("active") || '["where", "what", "who"]'
              )}
              bordered={false}
              className="simple-collapse"
              onChange={(active) => {
                localStorage.setItem("active", JSON.stringify(active));
              }}
            >
              <Panel
                header={
                  <div className="d-flex">
                    <ReactSVG src="/images/account-icon.svg" />
                    <h5 className="ml-3">Account</h5>
                  </div>
                }
                key="account"
              >
                <div className="sub-cards-2">
                  <Row>
                    <Col span={12} className="pr-2" xs={24} sm={12}>
                      <Form.Item name="accountNumber">
                        <Input placeholder="Account Number" />
                      </Form.Item>
                    </Col>
                    <Col span={12} className="pl-2" xs={24} sm={12}>
                      <Form.Item name="accountName">
                        <Input placeholder="Account Name" />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col span={24}>
                      <Form.Item name="accountContactName">
                        <Input placeholder="Contact name" />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col span={24}>
                      <Form.Item name="accountContactPhone">
                        <Input placeholder="Contact phone" />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col span={24}>
                      <Form.Item
                        name="accountContactEmail"
                        rules={[
                          {
                            required: false,
                            type: "email",
                            message: "**Enter a valid email address",
                          },
                        ]}
                      >
                        <Input placeholder="Contact email" />
                      </Form.Item>
                    </Col>
                  </Row>
                  <hr />
                  <Row className="mt-3">
                    <Col span={16} className="pr-2" xs={24} sm={16}>
                      <Form.Item name="accountContactAlternativePhone">
                        <Input placeholder="Alternative phone number" />
                      </Form.Item>
                    </Col>
                    <Col span={8} xs={24} sm={8}>
                      <Button className="beam-btn w-full more-btn">
                        Profile
                      </Button>
                    </Col>
                  </Row>

                  {cadExtendedSections?.["account"]?.map((row, j) => (
                    <Row className={"mt-3"}>
                      {row?.Cols.map((col, k) => (
                        <Col
                          span={col.ColSize}
                          className={k !== row?.Cols.length - 1 && "pr-2"}
                          xs={24}
                          sm={col.ColSize}
                        >
                          <RenderFields data={col} />
                        </Col>
                      ))}
                    </Row>
                  ))}
                </div>
              </Panel>
              <Panel
                header={
                  <div className="d-flex">
                    <ReactSVG src="/images/geo-icon.svg" />
                    <h5 className="ml-3">Where</h5>
                  </div>
                }
                key="where"
              >
                <div className="sub-cards-2">
                  <Row>
                    <Col span={20} className="pr-2" xs={24} sm={20}>
                      <Form.Item
                        rules={[
                          { required: true, message: "**Required Field" },
                        ]}
                        name="incidentLocation"
                      >
                        <LocationInput
                          placeholder="Incident Location"
                          onChange={(location) => {
                            addOtherLocation({ incidentLocation: location });
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={4} xs={24} sm={4}>
                      <Button
                        className="beam-btn w-full more-btn"
                        onClick={() => {
                          if (otherLocations["incidentLocation"]) {
                            setScreens({
                              ...screens,
                              map: true,
                              form: window.innerWidth >= 700,
                            });
                          }
                        }}
                      >
                        Map
                      </Button>
                    </Col>

                    {/* <Col span={4} className="pl-2" xs={24} sm={4}>
                      <Button className="beam-btn w-full more-btn">
                        Profile
                      </Button>
                    </Col> */}
                  </Row>
                  <Row className="mt-3">
                    <Col span={20} xs={24} sm={20}>
                      <Form.Item
                        rules={[]}
                        name="callerLocation"
                      >
                        <LocationInput
                          placeholder="Caller Location"
                          onChange={(location) => {
                            addOtherLocation({ callerLocation: location });
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={4} className="pl-2" xs={24} sm={4}>
                      <Button
                        className="beam-btn w-full more-btn"
                        onClick={() => {
                          let callerLocation =
                            nine11Form.getFieldValue("callerLocation");

                          if (callerLocation === undefined) return;

                          nine11Form.setFieldsValue({
                            incidentLocation: callerLocation,
                            incidentType: undefined,
                          });
                          dispatch({
                            type: SET_CURRENT_PROJECT,
                            payload: undefined,
                          });
                          addOtherLocation({
                            incidentLocation: callerLocation,
                          });
                        }}
                      >
                        Incident
                      </Button>
                    </Col>
                  </Row>

                  <Form.List name="otherLocations">
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map(({ key, name, ...restField }) => (
                          <Row className="mt-3" key={key}>
                            <Col span={10} className="pr-2" xs={24} sm={10}>
                              <Form.Item
                                {...restField}
                                name={[name, "location"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "**Required Field",
                                  },
                                ]}
                              >
                                <LocationInput
                                  placeholder="Location"
                                  onChange={(location) => {
                                    addOtherLocation({ [name]: location });
                                  }}
                                />
                              </Form.Item>
                            </Col>
                            <Col span={10} className="pr-2" xs={24} sm={10}>
                              <Form.Item
                                {...restField}
                                name={[name, "tag"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "**Required Field",
                                  },
                                ]}
                              >
                                <Input placeholder={"Tag"} />
                              </Form.Item>
                            </Col>
                            <Col span={4} xs={24} sm={4}>
                              <Form.Item>
                                <Button
                                  className="beam-btn w-full more-btn"
                                  onClick={() => {
                                    remove(name);
                                    removeOtherLocation(name);
                                  }}
                                >
                                  Remove
                                </Button>
                              </Form.Item>
                            </Col>
                          </Row>
                        ))}
                        <Row className="mt-3">
                          <Col span={24}>
                            <Form.Item>
                              <Button
                                className="beam-btn w-full more-btn"
                                onClick={() => {
                                  add();
                                }}
                              >
                                Add
                              </Button>
                            </Form.Item>
                          </Col>
                        </Row>
                      </>
                    )}
                  </Form.List>

                  {cadExtendedSections?.["where"]?.map((row, j) => (
                    <Row className={"mt-3"}>
                      {row?.Cols.map((col, k) => (
                        <Col
                          span={col.ColSize}
                          className={k !== row?.Cols.length - 1 && "pr-2"}
                          xs={24}
                          sm={col.ColSize}
                        >
                          <RenderFields data={col} />
                        </Col>
                      ))}
                    </Row>
                  ))}
                </div>
              </Panel>
              <Panel
                header={
                  <div className="d-flex">
                    <ReactSVG src="/images/pause-icon.svg" />
                    <h5 className="ml-3">What</h5>
                  </div>
                }
                key="what"
              >
                <div className="sub-cards-2">
                  <Row>
                    <Col span={12} xs={24} sm={12}>
                      <Form.Item
                        rules={[
                          { required: true, message: "**Required Field" },
                        ]}
                        name="incidentType"
                      >
                        <Select
                          showSearch
                          className="w-full"
                          placeholder="Incident Type"
                          onChange={(value) => {
                            onProjectChange(value);
                          }}
                          filterOption={(input, option) =>
                            (option!.children as unknown as string)
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                        >
                          {projects?.projects?.map((project, index) => (
                            <Option value={project.id}>{project.name}</Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={12} className="pl-2" xs={24} sm={12}>
                      <Form.Item
                        rules={[
                          { required: true, message: "**Required Field" },
                        ]}
                        name="incidentPriority"
                      >
                        <Select
                          className="w-full"
                          placeholder="Priority"
                          options={priorityOptions}
                        ></Select>
                      </Form.Item>
                    </Col>
                  </Row>
                  <hr />
                  <Row className="mt-3">
                    <Col span={24}>
                      <Form.Item
                        rules={[
                          { required: true, message: "**Required Field" },
                        ]}
                        name="incidentProtocols"
                      >
                        <TextArea
                          autoSize={{ minRows: 4, maxRows: 6 }}
                          placeholder="Protocols"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col span={8} className="pr-2" xs={24} sm={8}>
                      <Button className="beam-btn cover w-full">SURVEY</Button>
                    </Col>
                    <Col span={8} className="px-2" xs={24} sm={8}>
                      <Button className="beam-btn cover w-full">NCIC</Button>
                    </Col>
                    <Col span={8} className="pl-2" xs={24} sm={8}>
                      <Button className="beam-btn bordered w-full">
                        NFIRS
                      </Button>
                    </Col>
                  </Row>

                  {cadExtendedSections?.["what"]?.map((row, j) => (
                    <Row className={"mt-3"}>
                      {row?.Cols.map((col, k) => (
                        <Col
                          span={col.ColSize}
                          className={k !== row?.Cols.length - 1 && "pr-2"}
                          xs={24}
                          sm={col.ColSize}
                        >
                          <RenderFields data={col} />
                        </Col>
                      ))}
                    </Row>
                  ))}
                </div>
              </Panel>

              <Panel
                header={
                  <div className="d-flex">
                    <ReactSVG src="/images/clock.svg" />
                    <h5 className="ml-3">When</h5>
                  </div>
                }
                key="when"
              >
                <div className="sub-cards-2">
                  <Row>
                    <Col span={12} xs={24} sm={12}>
                      <div className="datetime-item">
                        <img src="/images/date.png" />
                        <Form.Item
                          name="incidentDate"
                          rules={[
                            { required: false, message: "**Required Field" },
                          ]}
                        >
                          <DateInput placeholder="Incident date" />
                        </Form.Item>
                      </div>
                    </Col>
                    <Col span={12} className="pl-2" xs={24} sm={12}>
                      <div className="datetime-item">
                        <img src="/images/time.png" />
                        <Form.Item
                          rules={[
                            { required: false, message: "**Required Field" },
                          ]}
                          name="incidentTime"
                        >
                          <TimeInput
                            name="Incident time"
                            onChange={(time) => {}}
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>

                  {cadExtendedSections?.["when"]?.map((row, j) => (
                    <Row className={"mt-3"}>
                      {row?.Cols.map((col, k) => (
                        <Col
                          span={col.ColSize}
                          className={k !== row?.Cols.length - 1 && "pr-2"}
                          xs={24}
                          sm={col.ColSize}
                        >
                          <RenderFields data={col} />
                        </Col>
                      ))}
                    </Row>
                  ))}
                </div>
              </Panel>

              <Panel
                header={
                  <div className="d-flex">
                    <ReactSVG src="/images/why.svg" />
                    <h5 className="ml-3">Why</h5>
                  </div>
                }
                key="why"
              >
                <div className="sub-cards-2">
                  <Row>
                    <Col span={24}>
                      <Form.Item name="incidentDescription">
                        <TextArea
                          autoSize={{ minRows: 4, maxRows: 6 }}
                          placeholder="Description"
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  {cadExtendedSections?.["why"]?.map((row, j) => (
                    <Row className={"mt-3"}>
                      {row?.Cols.map((col, k) => (
                        <Col
                          span={col.ColSize}
                          className={k !== row?.Cols.length - 1 && "pr-2"}
                          xs={24}
                          sm={col.ColSize}
                        >
                          <RenderFields data={col} />
                        </Col>
                      ))}
                    </Row>
                  ))}
                </div>
              </Panel>

              <Panel
                header={
                  <div className="d-flex">
                    <ReactSVG src="/images/user1-icon.svg" />
                    <h5 className="ml-3">Who</h5>
                  </div>
                }
                key="who"
              >
                <Form.List name="who">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }) => (
                        <div className="sub-cards-2" key={key}>
                          <Row>
                            <Col span={20} className="pr-2" xs={24} sm={20}>
                              <Form.Item
                                {...restField}
                                name={[name, "tag"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "**Required Field",
                                  },
                                ]}
                              >
                                {/* <Select
                                  className="w-full"
                                  placeholder="Tag"
                                  options={whoOptions}
                                ></Select> */}

<Input placeholder="Tag" />

                              </Form.Item>
                            </Col>
                            <Col span={4} xs={24} sm={4}>
                              <Form.Item>
                                <Button
                                  className="beam-btn w-full more-btn"
                                  onClick={() => {
                                    remove(name);
                                  }}
                                >
                                  Remove
                                </Button>
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            <Col span={12} xs={24} sm={12}>
                              <Form.Item
                                {...restField}
                                rules={[
                                  {
                                    required: true,
                                    message: "**Required Field",
                                  },
                                ]}
                                name={[name, "callerFirstName"]}
                              >
                                <Input placeholder="First Name" />
                              </Form.Item>
                            </Col>
                            <Col span={12} className="pl-2" xs={24} sm={12}>
                              <Form.Item
                                // rules={[
                                //   {
                                //     required: true,
                                //     message: "**Required Field",
                                //   },
                                // ]}
                                name={[name, "callerLastName"]}
                              >
                                <Input placeholder="Last name" />
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            <Col span={8} xs={24} sm={8}>
                              <div className="datetime-item">
                                <img src="/images/date.png" alt="" />
                                <Form.Item name={[name, "callerDateOfBirth"]}>
                                  <DateInput placeholder="Date of birth" />
                                </Form.Item>
                              </div>
                            </Col>

                            <Col span={8} className="pl-2" xs={24} sm={8}>
                              <Form.Item name={[name, "callerAge"]}>
                                <Input placeholder="Age" />
                              </Form.Item>
                            </Col>

                            <Col span={8} className="pl-2" xs={24} sm={8}>
                              <Form.Item name={[name, "callerGender"]}>
                                <Select
                                  className="w-full"
                                  placeholder="Gender"
                                  options={[
                                    { label: "Male", value: "Male" },
                                    { label: "Female", value: "Female" },
                                  ]}
                                ></Select>
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            <Col span={12} className="pr-2" xs={24} sm={12}>
                              <Form.Item
                                // rules={[
                                //   {
                                //     required: true,
                                //     message: "**Required Field",
                                //   },
                                // ]}
                                name={[name, "callerPhone"]}
                              >
                                <Input placeholder="Phone" />
                              </Form.Item>
                            </Col>

                            <Col span={12} xs={24} sm={12}>
                              <Form.Item
                                name={[name, "callerAlternativePhone"]}
                              >
                                <Input placeholder="Alternative Phone" />
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            <Col span={24}>
                              <Form.Item name={[name, "callerInstructions"]}>
                                <TextArea
                                  autoSize={{ minRows: 4, maxRows: 6 }}
                                  placeholder="Instructions"
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            <Col span={24}>
                              <Button className="beam-btn w-full more-btn">
                                Profile
                              </Button>
                            </Col>
                          </Row>
                        </div>
                      ))}
                      <Row className="mt-3">
                        <Col span={24}>
                          <Form.Item>
                            <Button
                              className="beam-btn w-full more-btn"
                              onClick={() => {
                                add();
                              }}
                            >
                              Add
                            </Button>
                          </Form.Item>
                        </Col>
                      </Row>
                    </>
                  )}
                </Form.List>

                <div className="sub-cards-2">
                  {cadExtendedSections?.["where"]?.map((row, j) => (
                    <Row className={"mt-3"}>
                      {row?.Cols.map((col, k) => (
                        <Col
                          span={col.ColSize}
                          className={k !== row?.Cols.length - 1 && "pr-2"}
                          xs={24}
                          sm={col.ColSize}
                        >
                          <RenderFields data={col} />
                        </Col>
                      ))}
                    </Row>
                  ))}
                </div>
              </Panel>

              {cadSections?.map((section, i) => (
                <Panel
                  header={
                    <div className="d-flex">
                      <h5 className="ml-3">{section.sectionName}</h5>
                    </div>
                  }
                  key={section.sectionName}
                >
                  <div className="sub-cards-2">
                    {section?.Rows.map((row, j) => (
                      <Row className={j > 0 ? "mt-3" : ""}>
                        <React.Fragment>
                          {!row.isMulti &&
                            row?.Cols.map((col, k) => (
                              <Col
                                span={col.ColSize}
                                className="pr-2"
                                xs={24}
                                sm={col.ColSize}
                              >
                                <RenderFields data={col} />
                              </Col>
                            ))}

                          {row.isMulti && (
                            <MultiInput
                              listName={`${section.sectionName}MultiRow${j}`}
                              cols={row?.Cols}
                              RenderFields={RenderFields}
                            />
                          )}
                        </React.Fragment>
                      </Row>
                    ))}
                  </div>
                </Panel>
              ))}
            </Collapse>
            <Row className="mt-3">
              <Col span={24}>
                <h4>Responder</h4>
                {selectedResponders &&
                  selectedResponders.map((responder, index) => (
                    <Row className="responder-item mt-3">
                      <Col span={4}>
                        <img
                          src={`/images/users/user.png`}
                          alt=""
                          width="50"
                          height="50"
                        />
                      </Col>
                      <Col span={8}>
                        <h5>{`${responder?.profile?.firstName} ${responder?.profile?.lastName}`}</h5>
                        <p>ID: {responder?.beamIds?.[0]}</p>
                      </Col>
                      <Col span={6}>
                        <Button className="beam-btn action-btn">
                          Responders
                        </Button>
                      </Col>
                      <Col span={6} className="t-right">
                        <Button className="beam-btn mr-2">
                          <img
                            src={`/images/flag-green.png`}
                            alt=""
                            width="15"
                            height="15"
                          />
                        </Button>
                      </Col>
                    </Row>
                  ))}
              </Col>
            </Row>
            <Row className="mt-3">
              <Col span={24}>
                <h4>Assets</h4>
                {selectedAssets &&
                  selectedAssets
                    .filter((x) => {
                      return x.assetType === "fixedAsset";
                    })
                    .map((asset, index) => (
                      <Row className="responder-item mt-3">
                        <Col span={4}>
                          <ReactSVG src="/images/map-line-icon.svg" />
                        </Col>
                        <Col span={8}>
                          <h5>{asset.location?.attributes?.title}</h5>
                          <p>{asset.location?.attributes?.description}</p>
                        </Col>
                        <Col span={6}>
                          <Button className="beam-btn action-btn">Asset</Button>
                        </Col>
                        <Col span={6} className="t-right"></Col>
                      </Row>
                    ))}
              </Col>
            </Row>

            <Row className="mt-3">
              <Col span={24}>
                <h4>POIs</h4>
                {selectedAssets &&
                  selectedAssets
                    .filter((x) => {
                      return x.assetType === "poi";
                    })
                    .map((asset, index) => (
                      <Row className="responder-item mt-3">
                        <Col span={4}>
                          <ReactSVG src="/images/map-star-icon.svg" />
                        </Col>
                        <Col span={8}>
                          <h5>{asset.location?.attributes?.title}</h5>
                          <p>{asset.location?.attributes?.description}</p>
                        </Col>
                        <Col span={6}>
                          <Button className="beam-btn action-btn">Poi</Button>
                        </Col>
                        <Col span={6} className="t-right"></Col>
                      </Row>
                    ))}
              </Col>
            </Row>
          </div>

          {error && (
            <Form.Item>
              <p className="error">{error}</p>
            </Form.Item>
          )}
          <Row className="action-grp mt-4">
            <Col span={8} className="pl-2" xs={24} sm={8}>
              <Button className="beam-btn orange-btn bordered w-full">
                Transfer
              </Button>
            </Col>
            <Col
              span={8}
              xs={24}
              sm={8}
              className="px-2"
              onClick={() => {
                // onSave();
              }}
            >
              <Button
                className="beam-btn yellow-btn cover w-full"
                loading={saving}
              >
                Save
              </Button>
            </Col>
            <Col span={8} className="pr-2" xs={24} sm={8}>
              <Form.Item>
                <Button
                  className="beam-btn green-btn cover w-full"
                  htmlType="submit"
                  loading={searching}
                >
                  Submit
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
};

export default DispatchPanel;
